<template>
  <button
    :type="type"
    :disabled="disabled"
    v-on="$listeners"
  >
    <component
      :is="hasLink ? linkComponent : 'span'"
      :class="clsx('violet-arrow-button', { 'violet-arrow-button--disabled': disabled })"
      v-bind="hasLink ? linkProps : {}"
    >
      <slot />
      <span class="violet-arrow-button__dot">
        <ChevronRightLineIcon :size="16" color="#6171E4" />
      </span>
    </component>
  </button>
</template>

<script>
import clsx from 'clsx';
import { ChevronRightLineIcon } from '@/shared/ui/icons';
import { HashAnchor, SmartLink } from '@/shared/ui/link';

export default {
  props: {
    type: {
      type: String,
      default: 'button',
      validator(value) { return ['button', 'submit', 'reset'].includes(value); },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    url: {
      type: String,
      default: null,
    },
    route: {
      type: [Object, String],
      default: null,
    },
    target: {
      type: String,
      default: '_self',
      validator(value) { return ['_blank', '_self', '_parent', '_top'].includes(value); },
    },
    method: {
      type: Function,
      default: null,
    },
    event: {
      type: String,
      default: null,
    },
    hash: {
      type: String,
      default: null,
    },
  },
  methods: { clsx },
  components: { SmartLink, HashAnchor, ChevronRightLineIcon },
  computed: {
    hasLink() {
      return this.url || this.route || this.hash;
    },
    linkComponent() {
      if (this.hash && !this.url && !this.route) {
        return 'HashAnchor';
      }

      return 'SmartLink';
    },
    linkProps() {
      const props = {
        disabled: this.disabled,
      };
      if (this.linkComponent === 'HashAnchor') {
        return {
          ...props,
          hash: this.hash,
        };
      } else {
        return {
          ...props,
          url: this.url,
          route: this.route,
          target: this.target,
          method: this.method,
          event: this.event,
          hash: this.hash,
        };
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.violet-arrow-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: 100%;
  padding: 8px 8px 8px 24px;
  border-radius: 12px;
  background: #6171E4;
  font-family: "IBM Plex Sans", sans-serif;
  font-size: 16px;
  font-weight: 600;
  color: #FFFFFF;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover:not(.violet-arrow-button--disabled) {
    background: #4555CC;
  }

  &--disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }

  &__dot {
    flex: none;
    width: 34px;
    height: 34px;
    border-radius: 50%;
    background: #FFFFFF;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
}

</style>
